export default {
  // campaign actions
  GET_ALL_CAMPAIGNS: "GET_ALL_CAMPAIGNS",
}
